import Vue from 'vue'

import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'

/* Plugins */

import nuxt_plugin_libplugineb94128a_29efa429 from 'nuxt_plugin_libplugineb94128a_29efa429' // Source: ./lib.plugin.eb94128a.js (mode: 'all')
import nuxt_plugin_vuewaitplugin_1c53c8d9 from 'nuxt_plugin_vuewaitplugin_1c53c8d9' // Source: ./vue-wait-plugin.js (mode: 'all')
import nuxt_plugin_gtm_4e110006 from 'nuxt_plugin_gtm_4e110006' // Source: ./gtm.js (mode: 'all')
import nuxt_plugin_cookieuniversalnuxt_1608fd0f from 'nuxt_plugin_cookieuniversalnuxt_1608fd0f' // Source: ./cookie-universal-nuxt.js (mode: 'all')
import nuxt_plugin_pluginutils_96ba8498 from 'nuxt_plugin_pluginutils_96ba8498' // Source: ./nuxt-i18n/plugin.utils.js (mode: 'all')
import nuxt_plugin_pluginrouting_662aa402 from 'nuxt_plugin_pluginrouting_662aa402' // Source: ./nuxt-i18n/plugin.routing.js (mode: 'all')
import nuxt_plugin_pluginmain_6fc215d0 from 'nuxt_plugin_pluginmain_6fc215d0' // Source: ./nuxt-i18n/plugin.main.js (mode: 'all')
import nuxt_plugin_router_1fc0ed28 from 'nuxt_plugin_router_1fc0ed28' // Source: ./router.js (mode: 'all')
import nuxt_plugin_plugin_0059d066 from 'nuxt_plugin_plugin_0059d066' // Source: ./composition-api/plugin.js (mode: 'all')
import nuxt_plugin_pluginsi18ncookies273e0417_83417b88 from 'nuxt_plugin_pluginsi18ncookies273e0417_83417b88' // Source: ./plugins.i18n-cookies.273e0417.js (mode: 'all')
import nuxt_plugin_pluginslogger37665b32_157505bd from 'nuxt_plugin_pluginslogger37665b32_157505bd' // Source: ./plugins.logger.37665b32.js (mode: 'all')
import nuxt_plugin_pluginsssrb4429ab6_5bbbc87b from 'nuxt_plugin_pluginsssrb4429ab6_5bbbc87b' // Source: ./plugins.ssr.b4429ab6.js (mode: 'all')
import nuxt_plugin_pluginscontextd3f58c30_2426cade from 'nuxt_plugin_pluginscontextd3f58c30_2426cade' // Source: ./plugins.context.d3f58c30.js (mode: 'all')
import nuxt_plugin_nuxtplugin6013db8e_4a845970 from 'nuxt_plugin_nuxtplugin6013db8e_4a845970' // Source: ./nuxt.plugin.6013db8e.ts (mode: 'all')
import nuxt_plugin_deviceplugin_0a124bf2 from 'nuxt_plugin_deviceplugin_0a124bf2' // Source: ./device.plugin.js (mode: 'all')
import nuxt_plugin_gtm_63637dfa from 'nuxt_plugin_gtm_63637dfa' // Source: ../plugins/gtm.ts (mode: 'client')
import nuxt_plugin_authusertocontext_39beb986 from 'nuxt_plugin_authusertocontext_39beb986' // Source: ../plugins/auth-user-to-context.ts (mode: 'client')
import nuxt_plugin_bootstrap_68fdc875 from 'nuxt_plugin_bootstrap_68fdc875' // Source: ../plugins/bootstrap.ts (mode: 'client')
import nuxt_plugin_index_21cdd825 from 'nuxt_plugin_index_21cdd825' // Source: ../plugins/metronic/index.ts (mode: 'client')
import nuxt_plugin_plugins_b64457d2 from 'nuxt_plugin_plugins_b64457d2' // Source: ../plugins/metronic/plugins.ts (mode: 'client')
import nuxt_plugin_scrollToTop_5cb8f2f6 from 'nuxt_plugin_scrollToTop_5cb8f2f6' // Source: ../plugins/scrollToTop.ts (mode: 'client')
import nuxt_plugin_components_50cb0ca1 from 'nuxt_plugin_components_50cb0ca1' // Source: ../plugins/components.ts (mode: 'client')
import nuxt_plugin_clickoutside_5b0e3843 from 'nuxt_plugin_clickoutside_5b0e3843' // Source: ../plugins/click-outside.ts (mode: 'client')
import nuxt_plugin_fulllocalizedurl_70705fb8 from 'nuxt_plugin_fulllocalizedurl_70705fb8' // Source: ../plugins/full-localized-url.ts (mode: 'all')
import nuxt_plugin_kftvalidationmodal_1ec08eaa from 'nuxt_plugin_kftvalidationmodal_1ec08eaa' // Source: ../plugins/kft-validation-modal.ts (mode: 'client')
import nuxt_plugin_meta_3c8398d4 from 'nuxt_plugin_meta_3c8398d4' // Source: ./composition-api/meta.js (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root.$options.$nuxt
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

async function createApp(ssrContext, config = {}) {
  const router = await createRouter(ssrContext, config)

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"title":"konfetti","meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"name":"theme-color","content":"#026166"},{"hid":"description","name":"description","content":"Finde Kurse und Erlebnisse in Deiner Stadt und Online. Für Dich, als Geschenkgutschein oder Teamevents - bei konfetti unkompliziert buchen."},{"hid":"og:description","name":"og:description","content":"Finde Kurse und Erlebnisse in Deiner Stadt und Online. Für Dich, als Geschenkgutschein oder Teamevents - bei konfetti unkompliziert buchen."},{"name":"generator","content":"konfetti"}],"link":[{"rel":"preconnect","href":"https:\u002F\u002Fapi.gokonfetti.com\u002F","crossOrigin":true},{"rel":"preconnect","href":"https:\u002F\u002Fdev.visualwebsiteoptimizer.com"},{"rel":"icon","type":"image\u002Fx-icon","href":"\u002Ffavicon.svg"},{"rel":"preload","type":"font\u002Fwoff2","as":"font","href":"\u002F_nuxt\u002Fstatic\u002Ffonts\u002Flexend\u002Flexend-v16-latin-regular.woff2","crossOrigin":true,"display":"swap"},{"rel":"preload","type":"font\u002Fwoff2","as":"font","href":"\u002F_nuxt\u002Fstatic\u002Ffonts\u002Flexend\u002Flexend-v16-latin-500.woff2","crossOrigin":true,"display":"swap"},{"rel":"preload","type":"font\u002Fwoff2","as":"font","href":"\u002F_nuxt\u002Fstatic\u002Ffonts\u002Flexend\u002Flexend-v16-latin-600.woff2","crossOrigin":true,"display":"swap"},{"rel":"preload","type":"font\u002Fwoff2","as":"font","href":"\u002F_nuxt\u002Fstatic\u002Ffonts\u002Fbootstrap\u002Fbootstrap-icons.woff2","crossOrigin":true,"display":"swap"}],"style":[],"script":[{"hid":"gtm-script","innerHTML":"if(!window._gtm_init){window._gtm_init=1;(function(w,n,d,m,e,p){w[d]=(w[d]==1||n[d]=='yes'||n[d]==1||n[m]==1||(w[e]&&w[e][p]&&w[e][p]()))?1:0})(window,navigator,'doNotTrack','msDoNotTrack','external','msTrackingProtectionEnabled');(function(w,d,s,l,x,y){w[x]={};w._gtm_inject=function(i){w[x][i]=1;w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s);j.crossOrigin='true';j.defer=true;j.src='https:\u002F\u002Fwww.googletagmanager.com\u002Fgtm.js?id='+i;f.parentNode.insertBefore(j,f);}})(window,document,'script','dataLayer','_gtm_ids','_gtm_inject')}"}],"noscript":[{"hid":"gtm-noscript","pbody":true,"innerHTML":"\u003Ciframe src=\"https:\u002F\u002Fwww.googletagmanager.com\u002Fns.html?id=GTM-MD5PHRG&\" height=\"0\" width=\"0\" style=\"display:none;visibility:hidden\" title=\"gtm\"\u003E\u003C\u002Fiframe\u003E"}],"__dangerouslyDisableSanitizersByTagID":{"gtm-script":["innerHTML"],"gtm-noscript":["innerHTML"]}},

    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_libplugineb94128a_29efa429 === 'function') {
    await nuxt_plugin_libplugineb94128a_29efa429(app.context, inject)
  }

  if (typeof nuxt_plugin_vuewaitplugin_1c53c8d9 === 'function') {
    await nuxt_plugin_vuewaitplugin_1c53c8d9(app.context, inject)
  }

  if (typeof nuxt_plugin_gtm_4e110006 === 'function') {
    await nuxt_plugin_gtm_4e110006(app.context, inject)
  }

  if (typeof nuxt_plugin_cookieuniversalnuxt_1608fd0f === 'function') {
    await nuxt_plugin_cookieuniversalnuxt_1608fd0f(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginutils_96ba8498 === 'function') {
    await nuxt_plugin_pluginutils_96ba8498(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginrouting_662aa402 === 'function') {
    await nuxt_plugin_pluginrouting_662aa402(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginmain_6fc215d0 === 'function') {
    await nuxt_plugin_pluginmain_6fc215d0(app.context, inject)
  }

  if (typeof nuxt_plugin_router_1fc0ed28 === 'function') {
    await nuxt_plugin_router_1fc0ed28(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin_0059d066 === 'function') {
    await nuxt_plugin_plugin_0059d066(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginsi18ncookies273e0417_83417b88 === 'function') {
    await nuxt_plugin_pluginsi18ncookies273e0417_83417b88(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginslogger37665b32_157505bd === 'function') {
    await nuxt_plugin_pluginslogger37665b32_157505bd(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginsssrb4429ab6_5bbbc87b === 'function') {
    await nuxt_plugin_pluginsssrb4429ab6_5bbbc87b(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginscontextd3f58c30_2426cade === 'function') {
    await nuxt_plugin_pluginscontextd3f58c30_2426cade(app.context, inject)
  }

  if (typeof nuxt_plugin_nuxtplugin6013db8e_4a845970 === 'function') {
    await nuxt_plugin_nuxtplugin6013db8e_4a845970(app.context, inject)
  }

  if (typeof nuxt_plugin_deviceplugin_0a124bf2 === 'function') {
    await nuxt_plugin_deviceplugin_0a124bf2(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_gtm_63637dfa === 'function') {
    await nuxt_plugin_gtm_63637dfa(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_authusertocontext_39beb986 === 'function') {
    await nuxt_plugin_authusertocontext_39beb986(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_bootstrap_68fdc875 === 'function') {
    await nuxt_plugin_bootstrap_68fdc875(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_index_21cdd825 === 'function') {
    await nuxt_plugin_index_21cdd825(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_plugins_b64457d2 === 'function') {
    await nuxt_plugin_plugins_b64457d2(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_scrollToTop_5cb8f2f6 === 'function') {
    await nuxt_plugin_scrollToTop_5cb8f2f6(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_components_50cb0ca1 === 'function') {
    await nuxt_plugin_components_50cb0ca1(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_clickoutside_5b0e3843 === 'function') {
    await nuxt_plugin_clickoutside_5b0e3843(app.context, inject)
  }

  if (typeof nuxt_plugin_fulllocalizedurl_70705fb8 === 'function') {
    await nuxt_plugin_fulllocalizedurl_70705fb8(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_kftvalidationmodal_1ec08eaa === 'function') {
    await nuxt_plugin_kftvalidationmodal_1ec08eaa(app.context, inject)
  }

  if (typeof nuxt_plugin_meta_3c8398d4 === 'function') {
    await nuxt_plugin_meta_3c8398d4(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    app,
    router
  }
}

export { createApp, NuxtError }
